export default {
  log: (...args) => {
    if (process.env.MIX_APP_ENV !== 'production')
      console.log(args.join(' '), 'time: ', new Date());
  },
  error: (...args) => {
    if (!process.env.MIX_APP_ENV !== 'production')
      console.error(args[0], 'time: ', new Date());
  },
  trace: (...args) => {
    process.env.MIX_APP_ENV !== 'production' &&
      args.forEach(each => console.trace(each, 'time: ', new Date())
      )
  }
}